

const UserInfoType = {
    ADD_USER_INFO: 'ADD_USER_INFO',
    FETCH_USER_INFO: 'FETCH_USER_INFO',
    SET_USER: 'SET_USER',
    FETCH_USERPAGE_INFO: 'FETCH_USERPAGE_INFO',
    FETCH_USER_INFO_PAGE: 'FETCH_USER_INFO_PAGE'
  };
  
  export default UserInfoType; 